<template>
  <BasePage title="Update Password">
    <div class="columns">
      <div class="column is-8-tablet is-6-desktop is-offset-3-desktop is-offset-2-tablet is-one-third-fullhd is-offset-one-third-fullhd">
        <section class="mt-4">

          <template v-if="setPassword">
            <h1 class="title is-2 mb-2">Set Password</h1>
            <p v-if="setPassword" class="title fs-6 mb-2 text-muted">Create a password to enable email and password.</p>
          </template>

          <h1 class="title is-2 mb-2" v-else>Change Password</h1>

          <form @submit.prevent="change()">

            <div class="field" v-if="!setPassword">
              <label class="label">Current Password</label>
              <p class="control">
                <input
                  v-focus
                  v-model="oldPassword"
                  :class="errorOld && 'is-danger'"
                  class="input"
                  type="password"
                  placeholder="old password"
                  />
                  <p v-if="errors.old" class="help is-danger">Incorrect password</p>
              </p>
            </div>

            <div class="field">
              <label class="label">New Password</label>
              <p class="control">
                <input
                  v-model="newPassword1"
                  :class="errorNewPasswords && 'is-danger'"
                  class="input"
                  type="password"
                  placeholder="new password"
                  />
                  <p v-if="errors.notMatching" class="help is-danger">Doesn't match</p>
                  <p v-if="errors.common" class="help is-danger">Too Common</p>
                  <p v-if="errors.short" class="help is-danger">Too Short</p>
              </p>
            </div>

            <div class="field">
              <label class="label">New Password (Again)</label>
              <p class="control">
                <input
                  v-model="newPassword2"
                  :class="errorNewPasswords && 'is-danger'"
                  class="input"
                  type="password"
                  placeholder="new password"
                  />
                  <p v-if="errors.notMatching" class="help is-danger">Doesn't match</p>
                  <p v-if="errors.common" class="help is-danger">Too Common</p>
                  <p v-if="errors.short" class="help is-danger">Too Short</p>
              </p>
            </div>

            <section class="d-flex justify-content-between flex-align-center">
              <button class="button is-primary" :class="loading && 'is-loading'" :disabled="!valid" type="submit">Update</button>
            </section>

          </form>
        </section>
      </div>
    </div>
  </BasePage>
</template>

<script>
import { focus } from '../directives.js'

import BasePage from './BasePage.vue'
import store from '../store'

export default {
  name: 'ChangePassword',
  data () {
    return {
      newPassword2: '',
      newPassword1: '',
      oldPassword: '',
      loading: false,
      errors: {
        notMatching: false,
        old: false,
        common: false,
        short: false,
      },
    }
  },
  components: {
    BasePage,
  },
  props: {
    setPassword: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    valid () {
      return this.newPassword2 !== '' && this.newPassword1 !== '' &&
      (this.oldPassword !== '' || this.setPassword)
    },
    errorNewPasswords () {
      return this.errors.notMatching || this.errors.short || this.errors.common
    },
    errorOld () {
      return this.errors.old
    },
  },
  methods: {
    change () {
      const { newPassword1, newPassword2, oldPassword } = this
      this.loading = true

      store.dispatch('updatePassword', { newPassword1, newPassword2, oldPassword })
        .then(() => {
          this.errors = {}
          this.loading = false
          this.errors.old = false
          store.commit('notify', {
            message: 'Updated password!',
            level: 'success',
          })
          this.$router.push('/')
        })
        .catch(error => {
          const data = error.response.data

          this.errors.short = data.new_password2 != null &&
            data.new_password2.join().includes('too short')

          this.errors.notMatching = data.new_password2 != null &&
            data.new_password2.join().includes('match')

          this.errors.common = data.new_password2 != null &&
            data.new_password2.join().includes('common')

          this.errors.old = data.old_password != null

          this.loading = false
        })
    },
  },
  directives: {
    focus,
  },
}
</script>

<style lang="scss" scoped>
.general.help {
  margin-bottom: .75rem;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// ChangePassword.vue?5e4dae60